import { isSameCalendarDayAs } from '@/utils/conversationDayLabel'

/** @typedef {import('./chatThreadTypes.js').ChatMessage} ChatMessage */

/**
 * @param {ChatMessage} currentUser
 * @param {ChatMessage | null} prevUser
 */
export function getExchangeDayDividerVisible(currentUser, prevUser) {
  if (!prevUser) return true
  // `currentUser` is null for an exchange a workflow posted with no question in
  // front of it. Nothing to date the row against, so no heading.
  if (!currentUser) return false
  if (typeof currentUser.createdAt !== 'number' || typeof prevUser.createdAt !== 'number') {
    return false
  }
  return !isSameCalendarDayAs(currentUser.createdAt, prevUser.createdAt)
}
